import * as React from "react";

import * as FontAwesome from "react-fontawesome";
import Dialog from "material-ui/Dialog";
import Checkbox from "@material-ui/core/Checkbox";
import Button from "@material-ui/core/Button";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { ColumnConfig } from "./ConfigurableTable";

type Props = {
  columnConfigs: ColumnConfig[];
  defaultColumns: string[];
  selectedColumns: string[];
  onSave: (selectedColumns: string[]) => void;
};

type State = {
  open: boolean;
  selectedColumns: string[];
};

export default class Config extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      open: false,
      selectedColumns: props.selectedColumns
    };
  }

  isChecked = (columnName: string): boolean =>
    this.state.selectedColumns.includes(columnName);

  toggleColumn = (columnName: string) => {
    if (this.isChecked(columnName)) {
      this.setState({
        selectedColumns: this.state.selectedColumns.filter(
          name => name !== columnName
        )
      });
    } else {
      this.setState({
        selectedColumns: this.props.columnConfigs
          .map(config => config.name)
          .filter(name => this.isChecked(name) || name === columnName)
      });
    }
  };

  setDefaults = () => {
    this.setState({
      selectedColumns: [...this.props.defaultColumns]
    });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    const setDefaultsButton = (
      <Button color="primary" onClick={this.setDefaults}>
        Defaults
      </Button>
    );
    const saveButton = (
      <Button
        color="primary"
        onClick={() => {
          this.props.onSave(this.state.selectedColumns);
          this.handleClose();
        }}
      >
        Save
      </Button>
    );
    const actions = [setDefaultsButton, saveButton];

    return (
      <>
        <Dialog
          title="Settings"
          modal={false}
          actions={actions}
          open={this.state.open}
          onRequestClose={this.handleClose}
        >
          {this.props.columnConfigs.map((config, i) => (
            <FormControlLabel
              key={i}
              style={{ width: "100%" }}
              control={
                <Checkbox
                  disabled={config.alwaysShow}
                  checked={this.isChecked(config.name)}
                  onChange={() => {
                    this.toggleColumn(config.name);
                  }}
                />
              }
              label={config.name}
            />
          ))}
        </Dialog>
        <a
          style={{ marginLeft: "6px" }}
          className="blueLink"
          href="#/"
          onClick={e => {
            e.preventDefault();
            this.setState({ open: true });
          }}
        >
          <FontAwesome name="cog" />
        </a>
      </>
    );
  }
}
